const vpsTitles = state => state.manuals.vps.titles;
const vpsArticles = state => state.manuals.vps.articles;

const monitoringTitles = state => state.manuals.monitoring.titles;
const monitoringArticles = state => state.manuals.monitoring.articles;

const videos = state => state.manuals.videos;

export default {
  vpsTitles,
  vpsArticles,

  monitoringTitles,
  monitoringArticles,

  videos,
};
